const YOUTUBE_PATTERN =
  /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

export function getYoutubeThumbnail(url: string): string | null {
  const match = url.match(YOUTUBE_PATTERN);
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
}
